<template>
  <v-menu offsetY>
    <template v-slot:activator="{ on }">
      <v-list
        class="px-0"
        rounded
        color="transparent"
        dense>
        <v-list-item
          class="grey lighten-3"
          v-on="on">
          <v-list-item-icon class="mr-1">
            <v-avatar
              color="primary"
              size="24">
              <span class="white--text">
                {{ user.email | initial }}
              </span>
            </v-avatar>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <div class="d-flex justify-space-between align-center">
                <div class="d-none d-md-block">
                  {{ user.email }}
                </div>
                <v-icon color="primary">
                  mdi-menu-down
                </v-icon>
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <v-card>
      <v-list dense rounded>
        <!-- <v-list-item v-if="$is() === 'manager'" link :to="{ name: 'Restaurants' }">
          Restaurantes
        </v-list-item>-->
       <v-list-item v-if="$is() === 'manager'" link href="" @click="myRestaurants()" >
          Mis restaurantes
        </v-list-item>
        <v-divider/>
        <v-list-item link href="" @click="profileInfo()">
          Datos del perfil
        </v-list-item>
        <v-list-item link href="" @click="lenguage()">
          Preferencias del sistema
        </v-list-item>
        <v-list-item link href="/logout">
          Cerrar sesión
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'UserMenu',
  computed: {
    user () {
      return this.$store.state.login.user || {}
    }
  },
  methods: {
    myRestaurants () {
      this.$router.push('/my-restaurants')
    },
    lenguage () {
      this.$router.push('/system-preference')
    },
    profileInfo () {
      this.$router.push('/profile-user')
    }
  }
}
</script>
